<template>
    <nav id="navigation" class="navbar navbar-fixed-top navbar-white shrink">
        <div class="container">
            <div class="row">
                <div class="navbar-header col-md-4">
                    <button @click="toggleMenu" type="button" class="navbar-toggle collapsed">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                    <a class="navbar-brand page-scroll font-family-alt letter-spacing-1 text-extra-large text-uppercase"
                       @click="goToMenuItem('home-bg-video')"
                    >
                        <div>
                            VW ERHVERVSKLUB
                            <span style="font-size:12px">
                                {{ this.$route.meta.retailerName }}
                            </span>
                        </div>
                    </a>
                </div>
                <div v-show="showMenu" id="navbar-deveo" class="navbar-collapse collapse in col-md-8 pull-right">
                    <ul class="nav navbar-nav font-family-alt letter-spacing-1 text-small text-uppercase">
                        <li><a @click="goToMenuItem('about')">Praktiske informationer</a></li>
                        <li><a @click="goToMenuItem('venue')">Få inspiration</a></li>
                        <li><a @click="goToMenuItem('ticket')">Pris</a></li>
                        <li><a @click="goToMenuItem('register')">Tilmelding</a></li>
                        <li><a @click="goToMenuItem('contact')">Kontakt</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
</template>
<script>
import $ from 'jquery'
export default{
    data () {
        return {
            showMenu: false
        }
    },
    methods: {
        toggleMenu () {
            this.showMenu = !this.showMenu
        },
        goToMenuItem (id) {
            this.showMenu = false
            $('html, body').animate({
                scrollTop: $('#' + id).offset().top
            }, 500)
        }
    }
}
</script>
<style lang="scss" scoped>
    ul.nav li a:hover, a.navbar-brand:hover{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// top-menu.vue?b3e4b8e4